import React from 'react'
import error from './error.svg'
function Blog() {
    return (
        <div className="blog">
            <h1 style={{ color:"white", alignItems:"center" ,textAlign:'center'}}>Page under construction</h1>
            <img src={error} alt=""/>
        </div>
    )
}

export default Blog
